import { useState, createContext } from "react";
import { Route, Routes } from "react-router-dom";
import SignUp from "./pages/SignUp";
import About from "./pages/About";
import Home from "./pages/Home";
import MoodTrack from "./pages/moodtrack/MoodTrack";
import SignIn from "./pages/SignIn";
import HelpAndSupport from "./pages/HelpAndSupport";
import MainResources from "./resources/MainResources";
import React from "react";
import Riddles from "./pages/Riddles";
import Jokes from "./pages/Jokes";
import VideoMain from "./resources/videos/VideoMain";
import PowerOfTwo from "./resources/videos/PowerOfTwo";
import Lonely from "./resources/videos/Lonely";
import Depression from "./resources/videos/Depression";
import Community from "./pages/Community";
import MainArticle from "./resources/articles/MainArticle";
import Mental from "./resources/articles/Mental";
import Treat from "./resources/articles/Treat";
import Benefit from "./resources/articles/Benefit";
import Maintherapy from "./pages/Maintherapy";
import Bookappointment from "./pages/Bookappointment";
import Profile from "./pages/profile/Profile";
import SettingsProfile from "./pages/profile/SettingsProfile";
import ChangePassword from "./pages/profile/ChangePassword";
// import ProfileLayout from "./pages/profile/ProfileLayout";
import Forum from "./pages/Forum";
import Premium from "./pages/therapy/Premium";
import Faq from "./pages/Faq";
import Supportfaq from "./pages/Supportfaq";
import MainAudioPage from "./resources/audios/MainAudioPage";
import MainPayment from "./pages/therapy/MainPayment";
import Chat from "./pages/therapy/contacttherapy/Chat";
import Voicecall from "./pages/therapy/contacttherapy/Voicecall";
import Videocall from "./pages/therapy/contacttherapy/Videocall";
import DailyLogs from "./pages/moodtrack/DailyLogs";
import Audio1 from "./resources/audios/Audio1";
import Audio2 from "./resources/audios/Audio2";
import Audio3 from "./resources/audios/Audio3";
import Audio4 from "./resources/audios/Audio4";
import Audio5 from "./resources/audios/Audio5";
import Audio6 from "./resources/audios/Audio6";
import SelectContactMode from "./pages/therapy/contacttherapy/SelectContactMode";
import Relaxation28 from "./pages/relaxation/Relaxation28";
import Relaxation1 from "./pages/relaxation/Relaxation1";
import Relaxation9 from "./pages/relaxation/Relaxation9";
import Relaxation8 from "./pages/relaxation/Relaxation8";
import Relaxation13 from "./pages/relaxation/Relaxation13";
import Relaxation23 from "./pages/relaxation/Relaxation23";
import Relaxation24 from "./pages/relaxation/Relaxation24";
import Relaxation29 from "./pages/relaxation/Relaxation29";
import Relaxation5 from "./pages/relaxation/Relaxation5";
import Relaxation11 from "./pages/relaxation/Relaxation11";
import Relaxation25 from "./pages/relaxation/Relaxation25";
import RelaxationLayout from "./pages/relaxation/RelaxationLayout";
import TherapistApplication from "./pages/therapy/TherapistApplication";
import EmailVerification from "./pages/EmailVerification";
import VerifiedEmail from "./pages/VerifiedEmail";
import MoodUi from "./pages/moodtrack/MoodUi";

import TherapistDashboard from "./pages/therapy/TherapistDashboard";

import PreviousMood from "./pages/moodtrack/PreviousMood";

export const UserContext = createContext();

export const videoContext = createContext();

function App() {
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
      ? JSON.parse(localStorage.getItem("userInfo"))
      : { firstName: "user" }
  );

  return (
    <UserContext.Provider value={{ userInfo, setUserInfo }}>
      <React.Fragment>
        <Routes>
          {/* <Route path="/" element={<TimelineWithAvatar />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/helpandsupport" element={<HelpAndSupport />} />
          <Route path="/about" element={<About />} />
          <Route path="/moodtrack" element={<MoodTrack />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/mainresources" element={<MainResources />} />
          <Route path="/videomain" element={<VideoMain />} />
          <Route path="/poweroftwo" element={<PowerOfTwo />} />
          <Route path="/depression" element={<Depression />} />
          <Route path="/lonely" element={<Lonely />} />
          <Route path="/riddles" element={<Riddles />} />
          <Route path="/jokes" element={<Jokes />} />
          <Route path="/community" element={<Community />} />
          <Route path="/mainarticle" element={<MainArticle />} />
          <Route path="/mental" element={<Mental />} />
          <Route path="/treat" element={<Treat />} />
          <Route path="/benefit" element={<Benefit />} />
          <Route path="/therapy" element={<Maintherapy />} />
          <Route path="/bookappointment" element={<Bookappointment />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settingsprofile" element={<SettingsProfile />} />
          <Route path="/mainaudiopage" element={<MainAudioPage />} />
          <Route path="/signin" element={<ChangePassword />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/mainpayment" element={<MainPayment />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/mainaudiopage" element={<MainAudioPage />} />
          <Route path="/audio1" element={<Audio1 />} />
          <Route path="/audio2" element={<Audio2 />} />
          <Route path="/audio3" element={<Audio3 />} />
          <Route path="/audio4" element={<Audio4 />} />
          <Route path="/audio5" element={<Audio5 />} />
          <Route path="/audio6" element={<Audio6 />} />
          <Route path="/videocall" element={<Videocall />} />
          <Route path="/voicecall" element={<Voicecall />} />
          <Route path="/selectcontactmode" element={<SelectContactMode />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/relaxation1" element={<RelaxationLayout />}>
            <Route index element={<Relaxation1 />} />
            <Route path="relaxation11" element={<Relaxation11 />} />
            <Route path="relaxation5" element={<Relaxation5 />} />
            <Route path="relaxation8" element={<Relaxation8 />} />
            <Route path="relaxation13" element={<Relaxation13 />} />
            <Route path="relaxation23" element={<Relaxation23 />} />
            <Route path="relaxation24" element={<Relaxation24 />} />
            <Route path="relaxation28" element={<Relaxation28 />} />
            <Route path="relaxation29" element={<Relaxation29 />} />
            <Route path="relaxation9" element={<Relaxation9 />} />
            <Route path="relaxation25" element={<Relaxation25 />} />
          </Route>
          <Route path="/supportfaq" element={<Supportfaq />} />
          <Route
            path="/therapistapplication"
            element={<TherapistApplication />}
          />
          <Route path="/emailverification" element={<EmailVerification />} />
          <Route path="/verifiedemail" element={<VerifiedEmail />} />
          <Route path="/dailylogs" element={<DailyLogs />} />
          <Route path="/therapistdashboard" element={<TherapistDashboard />} />
          <Route path="/moodui" element={<MoodUi />} />
          {/* <Route path="/moodui" element={<MoodUi />} />` */}
        </Routes>
      </React.Fragment>
    </UserContext.Provider>
  );
}

export default App;
